import React, { Component } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const bannerList = [
  {
    title: "banner old",
    href: "/promotion/",
    path: "/build/web/igame-index-lobby-wm/img/03-2.png",
  },

  {
    title: "banner 1",
    href: "/promotion/",
    path: "https://s3.newworld.center/image/fe654093-714d-4686-ad79-6823fc49bc49.webp",
  },

  {
    title: "banner 2",
    href: "/promotion/",
    path: "https://s3.newworld.center/image/5d8d0a78-f8a2-4518-95c2-cd904d269b17.webp",
  },

  {
    title: "banner 3",
    href: "/promotion/",
    path: "https://s3.newworld.center/image/120201b6-3861-474f-af86-6592b1cde421.webp",
  },

  {
    title: "banner 4",
    href: "/promotion/",
    path: "https://s3.newworld.center/image/f726e542-3cdb-496b-a4c5-556ec84d3d21.webp",
  },

  {
    title: "banner 5",
    href: "/promotion/",
    path: "https://s3.newworld.center/image/67b48cd2-adc7-4016-99e8-4b93e6b09deb.webp",
  },

  {
    title: "banner 6",
    href: "/promotion/",
    path: "https://s3.newworld.center/image/caeecb35-29a6-4c05-a9e2-e2e7e397f050.webp",
  },
];

const settings = {
  dots: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 3000,
  arrows: true,
  cssEase: "ease",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

class App extends Component {
  render() {
    return (
      <div className="slick-banner-wrap">
        <Slider {...settings}>
          {bannerList.map((item, index) => (
            <div className="slick-banner-item" key={index}>
              {item.href ? (
                <a href={item.href} title={item.title}>
                  <img
                    className="thaitheme_pc"
                    src={item.path}
                    alt={item.title || `Slide ${index + 1}`}
                  />
                </a>
              ) : (
                <img
                  className="thaitheme_pc"
                  src={item.path}
                  alt={item.title || `Slide ${index + 1}`}
                />
              )}
            </div>
          ))}
        </Slider>

        <style>{`
          .slick-banner-wrap {
            width: 100%;
            background: #000;
            overflow: hidden;
            padding-bottom: 22px;
          }

          .slick-banner-item {
            padding: 0 5px;
            box-sizing: border-box;
          }

          .slick-banner-item a {
            display: block;
          }

          .slick-banner-item img {
            width: 100%;
            height: auto;
            display: block;
          }

          .slick-list {
            margin: 0 -5px;
          }

          .slick-prev {
            left: 10px;
            z-index: 9;
          }

          .slick-next {
            right: 10px;
            z-index: 9;
          }

          .slick-prev:before,
          .slick-next:before {
            font-size: 34px;
            opacity: 0.8;
          }

          .slick-dots {
            bottom: 6px;
          }

          .slick-dots li button:before {
            color: #fff;
            opacity: 0.45;
            font-size: 10px;
          }

          .slick-dots li.slick-active button:before {
            color: #fff;
            opacity: 1;
          }

          @media (max-width: 768px) {
            .slick-banner-item {
              padding: 0;
            }

            .slick-list {
              margin: 0;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default App;